import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss', '../input/input.component.scss'],
})
export class TextareaComponent {
  @Input() public rows = 7;
  @Input() public maxLength = 255;
  @Input() public fc: UntypedFormControl;
  @Input() public styleClass: string;
  @Input() public label: string;
  @Input() public placeholder: string = '';
}
